import axios, { AxiosInstance } from "axios";
import Cookies from "js-cookie";
import apiConfig from "./config";

const createApiInstance = (baseURL: string): AxiosInstance => {
  const instance = axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
    },
  });
  // Request interceptor → attach Bearer token
  instance.interceptors.request.use(
    (config) => {
      if (typeof window !== "undefined") {
        const token = Cookies.get("auth_token");
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
      return config;
    },
    (error) => Promise.reject(error),
  );
  // Response interceptor → handle 401 (token expired / invalid)
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        if (typeof window !== "undefined") {
          Cookies.remove("auth_token", { path: "/" });
          window.location.href = "/";
        }
      }
      return Promise.reject(error);
    },
  );

  return instance;
};

// Main API instances
export const authenticatedApi = createApiInstance(apiConfig.api.baseUrl!);
export const authenticatedDriverPermitApi = createApiInstance(
  apiConfig.api.permitUrl!,
);
